import { Operation } from "@apollo/client";
import { GlobalUserAlert } from "@design-system";
import React, { FC } from "react";
import { ActionTypes, NetworkStatusAction } from "react-apollo-network-status";

type VPDNetworkStatusAction = Omit<NetworkStatusAction, "payload"> & {
  payload: {
    operation: Operation | undefined;
  };
};

type Props = {
  useApolloNetworkStatusReducer: <T>(
    reducer: (state: T, action: VPDNetworkStatusAction) => T,
    initialState: T
  ) => T;
};

const initialState = {
  type: ActionTypes.REQUEST,
  payload: {
    operation: undefined,
  },
} as VPDNetworkStatusAction;

const networkStatusReducer = (_: VPDNetworkStatusAction, action: VPDNetworkStatusAction) => {
  return action;
};

export const CrudUserFeedbackContainer: FC<Props> = ({ useApolloNetworkStatusReducer }) => {
  const state = useApolloNetworkStatusReducer(networkStatusReducer, initialState);
  return <GlobalUserAlert operation={state} />;
};
